import React from 'react';
import Footer from '@components/Footer/Footer';
import { MainContentWrapper } from '@app.styled';
import Header from './Header';
import IdleTimerContainer from '@components/IdleTimerContainer/IdleTimerContainer';
import Error from '@components/Error/Error';
import { UIConstants } from '@constants/UIConstants';
const { subHeading, unAuthUserSubHeadingErrorMsg, heading } = UIConstants.errorComponent;

const ErrorContainer: React.FunctionComponent<any> = ({ userName, isUnAuthUser }) => {
    const errorMsg = isUnAuthUser ? unAuthUserSubHeadingErrorMsg : subHeading;

    const errorTextHeading = isUnAuthUser ? '' : heading;
    return (
        <MainContentWrapper id="error">
            <Header name={userName} navigationOptions={UIConstants.navigationOptions} />
            {/* for unauth users we don't need homesection in error page */}
            <Error isHomeSectionNeeded={isUnAuthUser} errorMsg={errorMsg} errorTextHeading={errorTextHeading} />
            <IdleTimerContainer />
            <Footer />
        </MainContentWrapper>
    );
};

export const OKTAErrorContainer: React.FunctionComponent<any> = ({ error }: { error: Error }) => {
    console.log('okta error ', JSON.stringify(error));
    return (
        <MainContentWrapper id="error">
            <Header name={''} navigationOptions={UIConstants.navigationOptions} />
            {/* for unauth users we don't need homesection in error page */}
            <Error isHomeSectionNeeded={false} errorMsg={error.message} errorTextHeading={error.name} />
            <IdleTimerContainer />
            <Footer />
        </MainContentWrapper>
    );
};

export default ErrorContainer;
